import * as React from 'react'

import classNames from 'classnames/bind'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
// TODO This component could be extracted into a generalization
// It looks like Panes but it has a left fixed width and a sticky left component
// If so, give some cariño for more possible variations of it :)
type Type = 'third' | 'half'
interface Props {
  type?: Type
}

const Cols = ({ children, type = 'third' }: React.PropsWithChildren<Props>) => {
  if (React.Children.count(children) > 2) {
    throw Error('Cols only accepts two childrens!')
  }

  return (
    <ErrorBoundary>
      <div className={cx('cols', type)}>
        {React.Children.map(children, (element) => (
          <div className={styles.content}>
            <div>{element}</div>
          </div>
        ))}
      </div>
    </ErrorBoundary>
  )
}

export default Cols
